import React from 'react';
import ReactCountryFlag from 'react-country-flag';
import './HeroSection.css';

const SbxElliotHeroSection = ({ formData, onInputChange, onSubmit }) => {
  const [hasSubmitted, setHasSubmitted] = React.useState(false);

  // Mapeamento de códigos de país para códigos ISO
  const getCountryCode = (phoneCode) => {
    const countryMap = {
      '+55': 'BR',
      '+1': 'US', 
      '+351': 'PT',
      '+34': 'ES',
      '+33': 'FR',
      '+49': 'DE',
      '+39': 'IT',
      '+44': 'GB'
    };
    return countryMap[phoneCode] || 'BR';
  };

  const getCountryName = (phoneCode) => {
    const nameMap = {
      '+55': 'Brasil',
      '+1': 'EUA',
      '+351': 'Portugal', 
      '+34': 'Espanha',
      '+33': 'França',
      '+49': 'Alemanha',
      '+39': 'Itália',
      '+44': 'Reino Unido'
    };
    return nameMap[phoneCode] || 'Brasil';
  };

  return (
    <section id="hero-section" className="hero-section" aria-label="Seção principal da parceria SBX e Elliot">
      <div className="hero-content">
        <header className="hero-text-content">
          {/* Logos SBX + Elliot */}
          <div className="partnership-logos" style={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center', 
            gap: '20px', 
            marginBottom: '30px',
            flexWrap: 'wrap'
          }}>
            <img 
              src="https://cms.sbxtreinamentos.com.br/wp-content/uploads/2025/10/logo-sbx.png" 
              alt="SBX Treinamentos" 
              style={{ height: '50px', objectFit: 'contain' }}
            />
            <span style={{ color: 'white', fontSize: '24px', fontWeight: 'bold' }}>+</span>
            <img 
              src="https://elliot.com.br/wp-content/uploads/2024/12/Logo-Elliot-Horizontal.svg" 
              alt="Elliot Wave" 
              style={{ height: '40px', objectFit: 'contain' }}
            />
          </div>

          <h1 className="hero-title" style={{ textAlign: 'left', marginBottom: '20px', fontSize: '24px' }}>
            RECEBA 100% GRÁTIS 30DIAS DO INDICADOR QUE TEM 91,25% DE ASSERTIVIDADE NO MERCADO, MAIS 15DIAS OPERANDO JUNTO COM A SBX
          </h1>
          
          <h2 className="hero-subtitle" style={{ textAlign: 'left', marginBottom: '30px', fontSize: '18px' }}>
            Cadastre-se abaixo para receber esses bônus exclusivos de clientes Elliot
          </h2>

          <form 
            className="hero-form" 
            onSubmit={(e) => {
              setHasSubmitted(true);
              onSubmit(e);
            }}
            autoComplete="on"
          >
            <input
              type="text"
              placeholder="Nome"
              className="form-field"
              value={formData.nome}
              onChange={(e) => onInputChange('nome', e.target.value)}
              name="name"
              autoComplete="name"
              required
            />
            <input
              type="email"
              placeholder="Email"
              className="form-field"
              value={formData.email}
              onChange={(e) => onInputChange('email', e.target.value)}
              name="email"
              autoComplete="email"
              required
            />
            <div className="phone-input-container">
              <div className="country-selector-wrapper">
                <ReactCountryFlag 
                  countryCode={getCountryCode(formData.countryCode)}
                  svg
                  style={{
                    width: '24px',
                    height: '18px',
                    marginRight: '8px'
                  }}
                  title={getCountryName(formData.countryCode)}
                />
                <select 
                  className="country-select"
                  name="countryCode"
                  value={formData.countryCode}
                  onChange={(e) => onInputChange('countryCode', e.target.value)}
                  autoComplete="tel-country-code"
                >
                  <option value="+55">+55</option>
                  <option value="+1">+1</option>
                  <option value="+351">+351</option>
                  <option value="+34">+34</option>
                  <option value="+33">+33</option>
                  <option value="+49">+49</option>
                  <option value="+39">+39</option>
                  <option value="+44">+44</option>
                </select>
              </div>
              <input
                type="tel"
                placeholder="(11) 99999-9999"
                className={`form-field phone-input ${hasSubmitted && formData.countryCode === '+55' && formData.whatsapp.replace(/\D/g, '').length !== 11 ? 'phone-input-invalid' : ''}`}
                value={formData.whatsapp}
                onChange={(e) => onInputChange('whatsapp', e.target.value)}
                onInvalid={(e) => {
                  if (formData.countryCode === '+55') {
                    const phoneDigits = formData.whatsapp.replace(/\D/g, '');
                    if (phoneDigits.length !== 11) {
                      e.target.setCustomValidity('Insira um número válido');
                    } else {
                      e.target.setCustomValidity('');
                    }
                  }
                }}
                onInput={(e) => e.target.setCustomValidity('')}
                pattern={formData.countryCode === '+55' ? '\\(?[0-9]{2}\\)?\\s?[0-9]{5}-?[0-9]{4}' : '.*'}
                name="tel"
                autoComplete="tel"
                inputMode="tel"
                required
              />
            </div>
            <button type="submit" className="cta-button" style={{ width: 'fit-content' }}>
              QUERO RESGATAR OS BÔNUS
            </button>
          </form>
        </header>
        <div className="hero-image">
          <img 
            src="https://cms.sbxtreinamentos.com.br/wp-content/uploads/2025/10/hero-image-2.png" 
            alt="Eduardo - Mentor de Trading"
            className="hero-mentor-image"
          />
        </div>
      </div>
      <div className="hero-background">
        <div className="hero-dots-pattern"></div>
        <div className="hero-dots-pattern-secondary"></div>
        <div className="hero-gradient-overlay"></div>
        <div className="hero-diagonal-light"></div>
      </div>
    </section>
  );
};

export default SbxElliotHeroSection;